import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import renderCheckbox from './renderCheckbox';
import { TRANSLATE_TO_RUSSIAN } from '../../utils';
import renderSelect from './renderSelect';
import FieldError from '../../components/FieldError';


class RenderFieldSet extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedValue: props.fields.getAll().map(field => field.field_id.value), draggableItemId: '' };
  }

  onDragEnd = (result) => {
    const { moveItem } = this.props;
    if (!result.destination) {
      return;
    }
    const {
      destination: { index: destinationIndex },
      source: { index: sourceIndex },
    } = result;
    if (sourceIndex === destinationIndex) {
      return;
    }
    const { selectedValue } = this.state;
    const fieldsOrder = [...selectedValue];
    const dropedItem = fieldsOrder[sourceIndex];
    fieldsOrder.splice(sourceIndex, 1);
    fieldsOrder.splice(destinationIndex, 0, dropedItem);
    this.setState({ selectedValue: fieldsOrder });
    moveItem(sourceIndex, destinationIndex);
    this.setState({ draggableItemId: '' });
  }

  onDragStart = (result) => {
    this.setState({ draggableItemId: result.draggableId });
  }

  render() {
    const {
      fields,
      vacancyFields,
      meta: { error },
      isDisabled,
      fieldsValue,
    } = this.props;

    const { selectedValue, draggableItemId } = this.state;
    const selectOptions = vacancyFields.map(({ placeholder, type, id }) => ({
      label: `${placeholder} (тип: ${TRANSLATE_TO_RUSSIAN.vacancyFieldTypes[type]})`,
      value: id,
    }));

    const removeField = (index) => {
      fields.splice(index, 1);
      selectedValue.splice(index, 1);
    };


    return (
      <React.Fragment>
        <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
          <Droppable droppableId="fields">
            { provided => (
              <div className="render-field-item-list" {...provided.droppableProps} ref={provided.innerRef}>
                {fields.map((field, index) => {
                  const options = selectOptions.filter(option => (!selectedValue
                    .find(otherField => ((otherField === option.value) && (otherField !== selectedValue[index])))));
                  const isFirst = index === 0;
                  const isRequiredDisable = fieldsValue && fieldsValue[index].is_service_only;
                  return (
                    <React.Fragment key={field}>
                      {isFirst ? (
                        <div
                          key={field}
                          className="render-field-item"
                        >
                          <div className="render-field-item-select">
                            <span className="render-field-item-num">{`${1})`}</span>
                            <Field
                              name={`${field}.field_id`}
                              type="text"
                              label="Поле"
                              component={renderSelect}
                              options={options}
                              noOptionsMessage="Нет доступных полей"
                              placeholder="Выберите поле"
                              disabled={isFirst}
                            />
                          </div>
                        </div>)
                        : (
                          <Draggable key={field} draggableId={field} index={index}>
                            { provided => (
                              <div
                                key={field}
                                className="render-field-item"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div className="render-field-item-select">
                                  <span className="render-field-item-num">{`${index + 1})`}</span>
                                  <Field
                                    isDragging={field === draggableItemId}
                                    name={`${field}.field_id`}
                                    type="text"
                                    label="Поле"
                                    component={renderSelect}
                                    options={options}
                                    noOptionsMessage="Нет доступных полей"
                                    placeholder="Выберите поле"
                                    onChange={newValue => this.setState({
                                      selectedValue: selectedValue
                                        .map((value, indexValue) => (indexValue === index ? newValue.value : value)),
                                    })}
                                  />
                                </div>
                                <div className="render-field-item-bottom">
                                  <Field
                                    name={`${field}.required`}
                                    type="checkbox"
                                    label="Обязательное"
                                    component={renderCheckbox}
                                    disabled={isRequiredDisable}
                                  />
                                  <Field
                                    name={`${field}.is_service_only`}
                                    type="checkbox"
                                    label="Заметка"
                                    component={renderCheckbox}
                                  />
                                  <FontAwesomeIcon
                                    onClick={() => removeField(index)}
                                    className="item-icon"
                                    icon="trash-alt"
                                  />
                                </div>
                              </div>)}
                          </Draggable>
                        )}
                    </React.Fragment>);
                })}
                {provided.placeholder}
              </div>)}
          </Droppable>
        </DragDropContext>
        {error && <FieldError error={error} />}
        <button
          type="button"
          className="button-frame"
          onClick={() => {
            fields.push({ required: false });
            selectedValue.push(-1);
          }}
          disabled={isDisabled}
        >
        Добавить поле
        </button>
      </React.Fragment>
    );
  }
}

RenderFieldSet.defaultProps = {
  isDisabled: false,
  fieldSetId: 0,
  moveItem: () => {},
};

RenderFieldSet.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  vacancyFields: PropTypes.arrayOf(PropTypes.object).isRequired,
  isDisabled: PropTypes.bool,
  editFieldSetOrder: PropTypes.func.isRequired,
  fieldSetId: PropTypes.number,
  moveItem: PropTypes.func,
};

export default RenderFieldSet;
